import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

class SurveyGroupQuestionRow extends React.Component {

    onSurveyGroupQuestionOptionToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };

    onSurveyGroupQuestionClose = () => {
        this.setState({ addSurveyGroupQuestionState: false });
    };
    onDeleteSurveyGroupQuestion = (question) => {
        this.setState({ addSurveyGroupQuestionState: false });
        this.props.onDeleteSurveyGroupQuestion(question);
    };

    constructor() {
        super();
        this.state = {
            menuState: false,
            addSurveyGroupQuestionState: false,
        };
    }

    render() {
        const { surveyGroupQuestionId } = this.props;
        const { menuState } = this.state;
        const options = [
            'Delete',
        ];
        return (

            <div className="contact-item">
                <div className="col con-inf-mw-100">
                    <p className="mb-0">
                        <span className="text-truncate group-name">
                            {surveyGroupQuestionId}
                        </span>
                    </p>
                </div>
                <div>
                    <Dropdown isOpen={menuState}
                        toggle={this.onSurveyGroupQuestionOptionToggle.bind(this)}>
                        <DropdownToggle tag="span">
                            <span className="icon-btn text-grey pointer">
                                <i className="zmdi zmdi-more-vert zmdi-hc-lg" />
                            </span>
                        </DropdownToggle>
                        <DropdownMenu>
                            {options.map(option =>
                                <DropdownItem key={option} onClick={() => {
                                    if (option === 'Delete') {
                                        this.onDeleteSurveyGroupQuestion(surveyGroupQuestionId);
                                    }
                                }
                                }>
                                    {option}
                                </DropdownItem>,
                            )}
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
        )
    }
}

export default SurveyGroupQuestionRow;


// WEBPACK FOOTER //
// ./components/Agile/SurveyGroupQuestion/SurveyGroupQuestionList/SurveyGroupQuestionRow/index.js